import React, { useState } from 'react';
const defaultAuthData = {
    _id: null,
    roles: [],
    _type: null,
};
const AuthContext = React.createContext(defaultAuthData);
const AuthContextProvider = (props) => {
    const [authData, setAuthData] = useState(Object.assign({}, defaultAuthData));
    const callback = () => {
        setAuthData(Object.assign({}, defaultAuthData));
    };
    const setAuth = (data) => {
        setAuthData(data);
    };
    return (React.createElement(AuthContext.Provider, { value: {
            setAuth,
            authData,
            callback,
        } }, props.children));
};
/*
 * We need this HOC for class components to pass data through props
 */
const withAuthContext = (Component) => (props) => (React.createElement(AuthContext.Consumer, null, (authContextProps) => (React.createElement(Component, Object.assign({}, props, authContextProps)))));
export { AuthContext, AuthContextProvider, withAuthContext };
